module.exports = __webpack_public_path__ + "static/sec2-8ac92add4afefefdf058e4d00297a89e.png";